import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  IconButton,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  HStack,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  Text,
  ModalFooter,
  Tooltip,
  Select,
  useToast,
  Skeleton,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  addJobDepartmentAsync,
  deleteJobDepartmentAsync,
  fetchJobDepartmentsAsync,
  selectJobDepartments,
  updateJobDepartmentAsync,
} from "../../../JobPostingSlice/JobDepartment/JobDepartmentSlice";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

function JobDepartments() {
  const dispatch = useDispatch();
  const jobDepartments = useSelector(selectJobDepartments);
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(true);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const [newJobDepartment, setNewJobDepartment] = useState("");
  const [newJobStatus, setNewJobStatus] = useState("");
  const [error, setError] = useState(null);
  const [editJobDepartment, setEditJobDepartment] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobDepartment, setEditableJobDepartment] = useState(null);
  const [deletingDepartment, setDeletingDepartment] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        await dispatch(fetchJobDepartmentsAsync());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        showErrorToast("Failed to load job departments");
      }
    };
    loadData();
  }, [dispatch]);

  const showSuccessToast = (message) => {
    toast({
      title: "Success",
      description: message,
      status: "success",
      duration: 3000,
      isClosable: true,
      position: "top-right",
    });
  };

  const showErrorToast = (message) => {
    toast({
      title: "Error",
      description: message,
      status: "error",
      duration: 3000,
      isClosable: true,
      position: "top-right",
    });
  };

  const handleDelete = async (uuid) => {
    try {
      await dispatch(deleteJobDepartmentAsync(uuid));
      dispatch(fetchJobDepartmentsAsync());
      onClose2();
      showSuccessToast("Job department deleted successfully");
    } catch (error) {
      showErrorToast("Failed to delete job department");
    }
  };

  const openDeleteModal = (job) => {
    setDeletingDepartment(job);
    onOpen2();
  };

  const handleSave = async () => {
    if (!newJobDepartment.trim()) {
      setError("Job department cannot be empty");
      return;
    }

    if (!newJobStatus) {
      setError("Status cannot be empty");
      return;
    }

    const jobDepartment = {
      title: newJobDepartment,
      status: newJobStatus,
    };

    try {
      await dispatch(addJobDepartmentAsync(jobDepartment));
      dispatch(fetchJobDepartmentsAsync());
      setNewJobDepartment("");
      setNewJobStatus("");
      onClose1();
      showSuccessToast("Job department added successfully");
    } catch (err) {
      setError(err.message);
      showErrorToast("Failed to add job department");
    }
  };

  const handleEdit = (jobDepartment) => {
    setEditableJobDepartment(jobDepartment);
    setEditJobDepartment(jobDepartment.title);
    setEditJobStatus(jobDepartment.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (!editJobDepartment.trim()) {
      setError("Job department cannot be empty");
      return;
    }

    if (!editJobStatus) {
      setError("Status cannot be empty");
      return;
    }

    try {
      await dispatch(
        updateJobDepartmentAsync({
          uuid: editableJobDepartment.uuid,
          jobDepartmentData: {
            title: editJobDepartment,
            status: editJobStatus,
          },
        })
      );

      await dispatch(fetchJobDepartmentsAsync());
      setEditableJobDepartment(null);
      setEditJobDepartment("");
      setEditJobStatus("");
      setIsEditModalOpen(false);
      showSuccessToast("Job department updated successfully");
    } catch (err) {
      setError(err.message);
      showErrorToast("Failed to update job department");
    }
  };

  return (
    <div
      className="min-h-screen bg-adminbg p-4 contentAdmin"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="">
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Job Department List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add Job Department
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSave();
                    }}
                  >
                    <ModalBody py={6}>
                      <VStack spacing={6}>
                        <Grid
                          templateColumns="repeat(2, 1fr)"
                          gap={4}
                          width="100%"
                        >
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Department</FormLabel>
                              <Input
                                className=" "
                                color="black"
                                placeholder="Enter job department"
                                value={newJobDepartment}
                                onChange={(e) =>
                                  setNewJobDepartment(e.target.value)
                                }
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Status</FormLabel>
                              <Select
                                placeholder="Select job status"
                                value={newJobStatus}
                                onChange={(e) => setNewJobStatus(e.target.value)}
                                borderColor="black"
                                color="black"
                              >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </Grid>
                        {error && <Text color="red.500">{error}</Text>}
                      </VStack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="md">
                      <Button colorScheme="blue" mr={3} type="submit">
                        Save
                      </Button>
                      <Button onClick={onClose1}>Cancel</Button>
                    </ModalFooter>
                  </form>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                size="4xl"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit Job Department
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleUpdate();
                    }}
                  >
                    <ModalBody py={6}>
                      <VStack spacing={6}>
                        <Grid
                          templateColumns="repeat(2, 1fr)"
                          gap={4}
                          width="100%"
                        >
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Department</FormLabel>
                              <Input
                                className=" "
                                color="black"
                                placeholder="Enter Job Department"
                                value={editJobDepartment}
                                onChange={(e) =>
                                  setEditJobDepartment(e.target.value)
                                }
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Status</FormLabel>
                              <Select
                                placeholder="Select job status"
                                value={editJobStatus}
                                onChange={(e) => setEditJobStatus(e.target.value)}
                                borderColor="black"
                                color="black"
                              >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </Grid>
                        {error && <Text color="red.500">{error}</Text>}
                      </VStack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="md">
                      <Button colorScheme="blue" mr={3} type="submit">
                        Update
                      </Button>
                      <Button onClick={() => setIsEditModalOpen(false)}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </form>
                </ModalContent>
              </Modal>
              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                  <ModalHeader
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Confirm Deletion
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Text fontSize="md" textAlign="center">
                      Are you sure you want to delete{" "}
                      <Text as="span" fontWeight="semibold" color="red.500">
                        "{deletingDepartment?.title}"
                      </Text>
                      ?
                    </Text>
                  </ModalBody>
                  <ModalFooter display="flex" gap="2" justifyContent="center">
                    <Button
                      colorScheme="red"
                      w="40"
                      onClick={() => handleDelete(deletingDepartment.uuid)}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outline"
                      colorScheme="red"
                      w="40"
                      onClick={onClose2}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>

          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">S.No</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {isLoading ? (
                  // Show skeleton loading when data is loading
                  Array.from({ length: 5 }).map((_, index) => (
                    <Tr key={index}>
                      <Td>
                        <Skeleton height="20px" />
                      </Td>
                      <Td>
                        <Skeleton height="20px" />
                      </Td>
                      <Td>
                        <Skeleton height="20px" />
                      </Td>
                      <Td>
                        <HStack spacing={2}>
                          <Skeleton height="20px" width="20px" />
                          <Skeleton height="20px" width="20px" />
                        </HStack>
                      </Td>
                    </Tr>
                  ))
                ) : Array.isArray(jobDepartments) && jobDepartments.length > 0 ? (
                  [...jobDepartments]
                    .sort((a, b) => a?.uuid?.localeCompare(b.uuid))
                    .map((job, index) => (
                      <Tr key={job.uuid}>
                        <Td>{index + 1}</Td>
                        <Td>{job.title}</Td>
                        <Td textColor={job.status === "active" ? "green" : "red"} className="capitalize">
                          {job.status}
                        </Td>
                        <Td>
                          <HStack spacing={2}>
                            <Tooltip label="Edit Department" placement="top">
                              <IconButton
                                icon={<EditIcon />}
                                colorScheme="blue"
                                size="sm"
                                onClick={() => handleEdit(job)}
                                aria-label="Edit department"
                              />
                            </Tooltip>
                            <Tooltip label="Delete Department" placement="top">
                              <IconButton
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => openDeleteModal(job)}
                                aria-label="Delete department"
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobDepartments;